module.exports = __webpack_public_path__ + "img/servicehub-avatar.e9ace2e2.png";